import React from 'react';
import { Edit3, Eye, Trash2, Clock } from 'lucide-react';
import { TOOL_TYPE_CONFIG } from '../constants';

const ToolCard = ({ tool, onEdit, onDelete, onPreview }) => {
    const config = TOOL_TYPE_CONFIG[tool.type] || TOOL_TYPE_CONFIG.breath;
    const Icon = config.icon;

    return (
        <div className="bg-white rounded-xl border border-[#FFBB98] p-4 hover:border-[#7D8E95] transition-colors">
            <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2">
                    <div 
                        className="w-8 h-8 rounded-lg flex items-center justify-center"
                        style={{ backgroundColor: `${config.bgColor}40` }}
                    >
                        <Icon className="w-4 h-4" style={{ color: config.color }} />
                    </div>
                    <div>
                        <h4 className="font-medium text-[#1D6B6B]">{tool.name}</h4>
                        <span 
                            className="text-xs px-2 py-0.5 rounded-full"
                            style={{ backgroundColor: `${config.bgColor}40`, color: config.color }}
                        >
                            {config.label}
                        </span>
                    </div>
                </div>
                <div className="flex items-center gap-1">
                    {tool.duration > 0 && (
                        <span className="text-xs text-[#7D8E95] flex items-center gap-1">
                            <Clock className="w-3 h-3" />
                            {tool.duration}s
                        </span>
                    )}
                </div>
            </div>

            <p className="text-sm text-[#7D8E95] mb-3 line-clamp-2">
                {tool.instruction}
            </p>

            <div className="flex items-center gap-2">
                <button
                    onClick={() => onEdit(tool)}
                    className="flex-1 px-3 py-1.5 text-sm rounded-lg border border-[#FFBB98] text-[#1D6B6B] hover:bg-transparent transition-colors flex items-center justify-center gap-1"
                >
                    <Edit3 className="w-3 h-3" />
                    Edit
                </button>
                <button
                    onClick={() => onPreview(tool)}
                    className="px-3 py-1.5 text-sm rounded-lg border border-[#FFBB98] text-[#1D6B6B] hover:bg-transparent transition-colors"
                >
                    <Eye className="w-4 h-4" />
                </button>
                <button
                    onClick={() => onDelete(tool)}
                    className="px-3 py-1.5 text-sm rounded-lg border border-[#FFBB98] text-red-500 hover:bg-red-50 transition-colors"
                >
                    <Trash2 className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default ToolCard;
